/**
 * Created by Jaime Bonilla Venegas on 2017-06-19.
 *
 */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { List } from '../../components/data-containers';
import { Item } from './components';
import Form from '../../forms';
import * as actions from './actions';
import { SubHeader, EmptyList } from '../../components/layout';
import SortDown from 'material-ui/svg-icons/hardware/keyboard-arrow-down';
import IconButton from 'material-ui/IconButton';
import { getPagePermissions, CUSTOMS_CLEARENCE_STATUSES_PERMISSION } from '../../security/permissions';
import Snackbar from 'material-ui/Snackbar';

class Status extends Component {

    componentWillMount() {
        this.props.fetchData('statuses', 'statuses', 'clearenceStatuses?projection=clearenceStatusProjection');
    }

    formHandler(open, path, form) {
        this.props.notify({ op: 'update', path: 'formOpen', value: open });
        switch (path) {
            case 'NEW_STATUS':
                this.props.saveStatus(form);
                break;
            default:
        }
    }
    render() {
        const { formOpen, statuses, pagePermissions, showNotification = false, showMessage = "", notificationColor } = this.props;
        const styles = {
            smallIcon: {
                width: 23,
                height: 23,
            },
            small: {
                width: 23,
                height: 23,
                padding: 0,
                verticalAlign: -16,
            },
        };

        return (
            <div>
                <SubHeader
                    title="Estatus de Despachos"
                    showRefresh={false}
                    onPressHeaderButton={() => this.formHandler(true, 'formOpen')}
                    showAddButton={pagePermissions.create}
                />
                <div>
                    {
                        statuses.length === 0 ? <EmptyList /> :
                        statuses.map((status, index) => {
                            return (
                                <Item
                                    key={index}
                                    Status={status}
                                    allowUpdate={pagePermissions.update}
                                    allowDelete={pagePermissions.delete}
                                    onSave={(newStatus) => {
                                        //This is only updating the item on memory
                                        //Replace this with the action that saves results on server
                                        this.props.editStatus(newStatus, index);
                                    }}
                                />
                            );
                        })
                    }
                </div>

                <Form
                    title="Nuevo Status"
                    type="status"
                    open={formOpen}
                    actions={{}}
                    onModalClosed={() => this.formHandler(false, 'openForm')}
                    onSave={(form) => {
                        console.log('Form notifies until the form is valid', form);
                        this.formHandler(false, 'NEW_STATUS', form);
                    }}//Will return if form is valid to send it
                />

                <Snackbar
                    bodyStyle={{
                        top: 0,
                        bottom: 'auto',
                        backgroundColor: notificationColor,
                        maxWidth: "800px",
                        height: "55px",
                        lineHeight: "28px",
                        left: (window.innerWidth - 288) / 2,
                        /*transform: this.props.errorMessage ?
                          'translate3d(0, 0, 0)' :
                          "translate3d(0, "+ -(window.innerHeight - 100) + "px , 0)"*/
                    }}
                    open={showNotification}
                    message={showMessage}
                    autoHideDuration={4000}
                    onRequestClose={() => this.props.notify({ op: 'update', path: 'showNotification', value: false })}
                />
            </div>
        );
    }
}

const mapStateToProps = ({ statuses, userData, userData: { permissions } }) => {
    return {
        ...statuses,
        userData,
        pagePermissions: getPagePermissions(CUSTOMS_CLEARENCE_STATUSES_PERMISSION, permissions)
    };
};

export default connect(mapStateToProps, { ...actions })(Status);



// WEBPACK FOOTER //
// ./containers/status/index.js